export default __webpack_public_path__ + "static/media/No6Closed.551ca53c.jpg";